import { z } from 'zod';

export const ExternallyReferenced = z.object({
  externalReference: z.string().nullish(),
  externalProperties: z.record(z.string(), z.string()).nullish(),
});
